var _mask, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 511,
    height: 511
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 255.5,
    cy: 255.5,
    r: 255.5,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M503.234 91.5781C498.574 47.9141 464.09 13.4219 420.422 8.76562C310.914 -2.92188 201.086 -2.92188 91.582 8.76562C47.9141 13.4258 13.4258 47.9141 8.76562 91.5781C-2.92188 201.082 -2.92188 310.914 8.76562 420.418C13.4258 464.086 47.9141 498.574 91.5781 503.234C201.082 514.922 310.914 514.922 420.422 503.234C464.09 498.574 498.574 464.086 503.234 420.418C514.922 310.914 514.922 201.086 503.234 91.5781V91.5781Z",
    fill: "url(#paint0_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.387 110.098C471.254 71.3516 440.652 40.7461 401.902 36.6094C304.73 26.2422 207.27 26.2422 110.098 36.6094C71.3516 40.7461 40.7461 71.3516 36.6094 110.098C26.2422 207.27 26.2422 304.73 36.6094 401.898C40.7461 440.648 71.3516 471.254 110.098 475.387C207.27 485.758 304.73 485.758 401.898 475.387C440.648 471.254 471.254 440.648 475.387 401.898C485.758 304.73 485.758 207.27 475.387 110.098V110.098Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.67188 409.805C8.02344 413.344 8.38672 416.883 8.76562 420.422C13.4258 464.086 47.9141 498.574 91.582 503.234C201.086 514.922 310.918 514.922 420.422 503.234C464.09 498.574 498.574 464.086 503.234 420.422C503.613 416.883 503.977 413.344 504.332 409.805H7.67188Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.234 420.418C509.516 361.578 512.414 302.645 511.945 243.719L394.914 126.687C380.293 109.996 358.938 99.5781 333.844 98.6758C282.238 96.8164 230.469 96.9101 178.855 98.6836C135.988 100.16 106.012 128.973 98.3242 171.32C96.9687 178.797 96.1562 186.371 95.0898 193.902V318.051C95.6797 322.074 96.5469 326.078 96.8164 330.125C98.5352 355.883 109.121 377.945 126.07 392.871L245.164 511.961C303.609 512.371 362.059 509.465 420.422 503.234C464.09 498.574 498.574 464.086 503.234 420.418V420.418Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.234 420.422C498.578 464.082 464.082 498.578 420.422 503.234C362.066 509.461 303.605 512.371 245.168 511.961L126.254 393.047C140.039 405.113 158.008 412.461 178.859 413.246C230.461 415.184 282.242 415.133 333.844 413.273C380.516 411.586 414.289 377.043 415.746 330.371C417.301 280.816 417.301 231.133 415.746 181.578C415.082 160.047 407.523 141.102 394.992 126.766L511.949 243.723C512.41 302.641 509.512 361.582 503.234 420.422Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.414 200.559C301.422 184.234 279.91 173.992 256 173.992C210.711 173.992 173.992 210.711 173.992 256C173.992 279.91 184.234 301.422 200.559 316.414L390.297 506.152C400.34 505.277 410.383 504.305 420.418 503.234C464.086 498.574 498.574 464.086 503.234 420.418C504.305 410.383 505.277 400.34 506.152 390.297L316.414 200.559Z",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.008 311.152L358.305 158.453C354.742 153.777 349.129 150.742 342.797 150.742C332.023 150.742 323.285 159.477 323.285 170.254C323.285 176.586 326.32 182.199 330.996 185.762L508.277 363.047C509.48 345.754 510.391 328.453 511.008 311.152V311.152Z",
    fill: "url(#paint6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0898 193.902C96.1562 186.371 96.9687 178.797 98.3242 171.32C106.008 128.973 135.988 100.16 178.855 98.6836C230.469 96.9101 282.238 96.8164 333.844 98.6758C380.5 100.355 414.289 134.902 415.746 181.574C417.297 231.133 417.297 280.812 415.746 330.371C414.289 377.043 380.512 411.586 333.848 413.27C282.242 415.133 230.461 415.18 178.859 413.242C132.195 411.488 99.9375 376.863 96.8164 330.121C96.5469 326.078 95.6797 322.07 95.0898 318.047C95.0898 276.664 95.0898 235.281 95.0898 193.902V193.902ZM256.043 385.609C279.66 385.609 303.301 386.316 326.887 385.445C363.867 384.074 386.613 362.004 387.477 325.059C388.547 279.023 388.547 232.926 387.477 186.887C386.613 149.949 363.852 127.363 326.887 126.578C279.969 125.586 233 125.594 186.082 126.578C149.398 127.348 126.586 149.477 125.59 186.008C124.324 232.625 124.324 279.324 125.59 325.941C126.586 362.469 149.398 384.086 186.086 385.445C209.375 386.313 232.723 385.609 256.043 385.609V385.609Z",
    fill: "url(#paint7_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0898 193.902C96.1562 186.371 96.9687 178.797 98.3242 171.32C106.008 128.973 135.988 100.16 178.855 98.6836C230.469 96.9101 282.238 96.8164 333.844 98.6758C380.5 100.355 414.289 134.902 415.746 181.574C417.297 231.133 417.297 280.812 415.746 330.371C414.289 377.043 380.512 411.586 333.848 413.27C282.242 415.133 230.461 415.18 178.859 413.242C132.195 411.488 99.9375 376.863 96.8164 330.121C96.5469 326.078 95.6797 322.07 95.0898 318.047C95.0898 276.664 95.0898 235.281 95.0898 193.902V193.902ZM256.043 385.609C279.66 385.609 303.301 386.316 326.887 385.445C363.867 384.074 386.613 362.004 387.477 325.059C388.547 279.023 388.547 232.926 387.477 186.887C386.613 149.949 363.852 127.363 326.887 126.578C279.969 125.586 233 125.594 186.082 126.578C149.398 127.348 126.586 149.477 125.59 186.008C124.324 232.625 124.324 279.324 125.59 325.941C126.586 362.469 149.398 384.086 186.086 385.445C209.375 386.313 232.723 385.609 256.043 385.609V385.609Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 173.996C210.711 173.996 173.992 210.711 173.992 256C173.992 301.293 210.711 338.008 256 338.008C301.293 338.008 338.008 301.293 338.008 256C338.008 210.711 301.293 173.996 256 173.996ZM256 309.773C226.301 309.773 202.227 285.699 202.227 256C202.227 226.301 226.301 202.227 256 202.227C285.699 202.227 309.773 226.301 309.773 256C309.773 285.699 285.699 309.773 256 309.773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.305 170.254C362.305 181.027 353.57 189.762 342.797 189.762C332.023 189.762 323.285 181.027 323.285 170.254C323.285 159.477 332.023 150.742 342.797 150.742C353.57 150.742 362.305 159.477 362.305 170.254Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(104.957 447.447) scale(564.646)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAE100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0544,
    stopColor: "#FADC04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1167,
    stopColor: "#FBCE0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1829,
    stopColor: "#FCB720"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    stopColor: "#FE9838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3054,
    stopColor: "#FF7950"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4922,
    stopColor: "#FF1C74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C1CD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 196.373,
    y1: 222.46,
    x2: -671.016,
    y2: -265.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1B5D8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3094,
    stopColor: "#90A2BD",
    stopOpacity: 0.309804
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7554,
    stopColor: "#7C8B9C",
    stopOpacity: 0.756863
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#748290"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 256,
    y1: 451.966,
    x2: 256,
    y2: 531.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAE100",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3068,
    stopColor: "#FCA800",
    stopOpacity: 0.305882
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6275,
    stopColor: "#FE7300",
    stopOpacity: 0.627451
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8685,
    stopColor: "#FF5200",
    stopOpacity: 0.866667
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 226.872,
    y1: 226.148,
    x2: 100.161,
    y2: 99.4361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#833AB4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#833AB4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 350.9,
    y1: 468.287,
    x2: 287.656,
    y2: 170.138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#833AB4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#833AB4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 374.965,
    y1: 374.965,
    x2: 120.941,
    y2: 120.941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#833AB4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#833AB4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 393.807,
    y1: 221.263,
    x2: 309.806,
    y2: 137.262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#833AB4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#833AB4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 357.658,
    y1: 155.05,
    x2: 150.543,
    y2: 362.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#833AB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0922,
    stopColor: "#9C3495"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2927,
    stopColor: "#DC2546"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392,
    stopColor: "#FD1D1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5589,
    stopColor: "#FC6831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6887,
    stopColor: "#FC9B40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7521,
    stopColor: "#FCAF45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7806,
    stopColor: "#FDB750"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8656,
    stopColor: "#FECB6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9415,
    stopColor: "#FFD87A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDC80"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.3f4d58f9514c97cb3ade8c34082b9284.svg";
export { ForwardRef as ReactComponent };